import {Endpoint} from '../endpoint';
import {
    CompactTimeMaterialTemplateResponse,
    TimeMaterialTemplateId,
    TimeMaterialTemplateResponse,
    TimeMaterialTemplateRequest,
    TemplateStepResponse,
} from '@business/entities/tm';

export function fetchTMTemplates() {
    return Endpoint.get<CompactTimeMaterialTemplateResponse[]>('@gc/time-material/template');
}

export function fetchTMTemplate(id: TimeMaterialTemplateId) {
    return Endpoint.get<TimeMaterialTemplateResponse>(`@gc/time-material/template/template/${id}`);
}

export function createTMTemplate(data: TimeMaterialTemplateRequest) {
    return Endpoint.post<TimeMaterialTemplateResponse>(`@gc/time-material/template/create`, {data});
}

export function updateTMTemplate(id: TimeMaterialTemplateId, data: TimeMaterialTemplateRequest) {
    return Endpoint.patch<TimeMaterialTemplateResponse>(`@gc/time-material/template/${id}`, {data});
}

export function duplicateTMTemplate(id: TimeMaterialTemplateId, data: TimeMaterialTemplateRequest) {
    return Endpoint.post<TimeMaterialTemplateResponse>(`@gc/time-material/template/duplicate/${id}`, {data});
}

export function deleteTMTemplate(tempId: TimeMaterialTemplateId) {
    return Endpoint.delete<void>(`@gc/time-material/template/${tempId}`);
}

/** Section **/
export function createTemplateSection(id: TimeMaterialTemplateId, name: string, isPublic = false) {
    return Endpoint.post<void>(`@gc/time-material/template/section/${id}`, {data: {name, isPublic}});
}

export function updateTemplateSection(id: number, name: string, isPublic = false) {
    return Endpoint.patch<void>(`@gc/time-material/template/section/${id}`, {data: {name, isPublic}});
}

export function deleteTemplateSection(id: number) {
    return Endpoint.delete<void>(`@gc/time-material/template/section/${id}`);
}

export function sortSections(ids: number[]) {
    return Endpoint.post<void>(`@gc/time-material/template/sort-section`, {data: {ids}});
}

/** Step **/
export function fetchStep(id: number) {
    return Endpoint.get<TemplateStepResponse>(`@gc/time-material/template/step/${id}`);
}

export function createTemplateStep(id: number, data: Partial<TemplateStepResponse>, parentStepId?: number) {
    data.parentId = parentStepId;
    return Endpoint.post<void>(`@gc/time-material/template/step/${id}`, {data});
}

export function updateTemplateStep(id: number, data: Partial<TemplateStepResponse>) {
    return Endpoint.patch<void>(`@gc/time-material/template/step/${id}`, {data});
}

export function deleteTemplateStep(id: number) {
    return Endpoint.delete<void>(`@gc/time-material/template/step/${id}`);
}

export function sortSectionSteps(ids: number[]) {
    return Endpoint.post<void>(`@gc/time-material/template/sort-step`, {data: {ids}});
}
